(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swan-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-swan-gallery]').forEach((gallery) => {
    gallery.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-swan-thumbnail]');
      if (!thumbnail) return;
      const image = gallery.querySelector('.swan-main-image');
      if (!image) return;
      image.src = thumbnail.dataset.image;
      image.removeAttribute('srcset');
      image.alt = thumbnail.dataset.alt || '';
      gallery.querySelectorAll('[data-swan-thumbnail]').forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      thumbnail.classList.add('is-active');
      thumbnail.setAttribute('aria-pressed', 'true');
    });
  });

  document.querySelectorAll('[data-swan-product]').forEach((product) => {
    product.addEventListener('change', (event) => {
      const option = event.target.closest('[data-swan-variant]');
      if (!option) return;
      const price = product.querySelector('[data-swan-price]');
      const compare = product.querySelector('[data-swan-compare]');
      const submit = product.querySelector('[data-swan-submit]');
      price.textContent = option.dataset.price;
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      submit.disabled = option.dataset.available !== 'true';
      product.querySelectorAll('.swan-pack').forEach((pack) => pack.classList.remove('is-selected'));
      option.closest('.swan-pack').classList.add('is-selected');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
